import type { FC } from "react";

import { ErrorBoundary } from "@/components/ErrorBoundary/ErrorBoundary";

import type { ContentProps } from "./ContentProps";
import { SafeBuilderContent } from "./SafeBuilderContent";

export const Content: FC<ContentProps> = (props) => {
  return (
    <ErrorBoundary fallback={props.fallback}>
      <SafeBuilderContent {...props} />
    </ErrorBoundary>
  );
};
